import React from 'react';

const FeedbackQuestionCard = ({
  number,
  label,
  helper,
  error,
  children,
  htmlFor,
}) => {
  const cardClass = ['ef-card', error ? 'ef-card--error' : ''].filter(Boolean).join(' ');

  return (
    <div className={cardClass}>
      {number && <span className="ef-card__number">{number}</span>}
      {label && (
        <label className="ef-card__label" htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {helper && <p className="ef-card__helper">{helper}</p>}
      {children}
      {error && <p className="ef-card__error" role="alert">{error}</p>}
    </div>
  );
};

export default FeedbackQuestionCard;
